import React, { useState } from 'react';
import { IonHeader, IonToolbar, IonPage, IonTitle, IonContent, IonLoading, IonButton, useIonViewWillEnter } from '@ionic/react';
import '../components/Loader.css';

const Loader = (props) => {
  const [showLoading, setShowLoading] = useState(props.lodingData);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Loader</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonButton onClick={() => setShowLoading(props.lodingData)}>Show Loading</IonButton>
        <IonLoading
          cssClass='loader-style'
          isOpen={props.lodingData}
          onDidDismiss={() => setShowLoading(props.lodingData)}
          message={'Loading...'}
        />
      </IonContent>
    </IonPage>
  );
};

export default Loader;